<!-- Zone message dans layout -->

<ng-container *ngIf="data.message">
  <div mat-dialog-title class="d-flex align-item-center" [ngClass]="classes">
    <span *ngIf="data.message.matIcon" class="message-icon">
      <mat-icon class="fs">{{ data.message.matIcon }}</mat-icon>
    </span>
    <span *ngIf="data.message.title" class="message-title strong mb-05">
      {{ data.message.title }}
    </span>
  </div>
  <div [ngClass]="classes">
    <div mat-dialog-content class="message-bar-wrapper">
      <div class="inner">
        <p *ngIf="data.message.body">{{ data.message.body }}</p>
        <ul *ngIf="data.message.list">
          <li *ngFor="let text of data.message.list">{{ text }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="justify-content-end">
    <button mat-button mat-dialog-close>close</button>
  </div>
</ng-container>
